import { render, staticRenderFns } from "./ZixiOutputDocument.vue?vue&type=template&id=44a7c454"
import script from "./ZixiOutputDocument.vue?vue&type=script&lang=js"
export * from "./ZixiOutputDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports